import { useState } from "react";
import { Header } from "../components/landing/Header";
import { Hero } from "../components/landing/Hero";
import { Marquee } from "../components/landing/Marquee";
import { Occasions } from "../components/landing/Occasions";
import { MenuShowcase } from "../components/landing/MenuShowcase";
import { Process } from "../components/landing/Process";
import { Inquiry } from "../components/landing/Inquiry";
import { Footer } from "../components/landing/Footer";

export default function Landing() {
  const [dishes, setDishes] = useState([]);
  const toggle = (d) => setDishes((p) => (p.includes(d) ? p.filter((x) => x !== d) : [...p, d]));

  return (
    <main data-testid="landing-page">
      <Header />
      <Hero />
      <Marquee />
      <Occasions />
      <MenuShowcase selected={dishes} onToggle={toggle} />
      <Process />
      <Inquiry dishes={dishes} onToggle={toggle} onClear={() => setDishes([])} />
      <Footer />
    </main>
  );
}
